import React, { useEffect, useRef } from 'react';
import { getLogs, getLogById, createLog } from '../../Services/LogService';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setModuleName } from '../../Stores/Action/AppAction';

const { $ } = window;

const LogScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const mTable = useRef();
    useEffect(() => {
        dispatch(setModuleName('Logs'));
    }, []);


    const columns = [
        { id: 1, title: 'Type', field: 'log_type', sortable: true },
        { id: 2, title: 'Asset ID', field: 'asset_id', sortable: true },
        { id: 3, title: 'Asset', field: 'asset_name', sortable: true },
        { id: 4, title: 'Uploaded Title', field: 'upload_title', sortable: true },
        { id: 5, title: 'Access Date', field: 'created_on', sortable: true },
        {
            id: 6,
            title: 'Accessed User',
            sortable: false,
            render: data => {
                return data.user.username;
            },
        },
    ];

    const propsTable = { columns, getData: getLogs, showIndex: true, showAddButton: false, filterRule: 'filter' };

    return (
        <div className="content-wrapper">
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-12'>
                            <div className='card'>
                                <div className='card-header'>
                                    <div className='card-title'><i className='fa fa-user-tag' /> List Log</div>
                                </div>
                                <div className='card-body'>
                                    <MTable ref={mTable} {...propsTable} order="created_by" />
                                </div>
                                <div className='card-footer'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LogScreen;